@if (isAuthenticated()) {
  <div class="dashboard-wrapper">
    <app-sidebar></app-sidebar>
    <div class="main-content">
      <app-header></app-header>
      <app-alert></app-alert>
      <router-outlet></router-outlet>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
